module.exports = __webpack_public_path__ + "static/media/hpv6.32e9813a.webp";